import {
    CorporationKcfInformationUpdateRequest,
    CorporationUpdateRequest,
    ICorporationKcfInformationResponse,
    ICorporationKcfInformationUpdateRequest,
    ICorporationResponse,
    ICorporationUpdateRequest,
} from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';

function createUpdateResponse({
    Active,
    Industry,
    ...corporation
}: ICorporationResponse): ICorporationUpdateRequest {
    return {
        Active,
        IndustryId: Industry?.IndustryId,
        ...corporation,
    };
}

export async function updateCorporation(
    corporation: ICorporationResponse,
    updates: Partial<ICorporationUpdateRequest>
) {
    const initialValue = createUpdateResponse(corporation);
    return sdClient.updateCorporation({
        id: corporation.Id,
        body: new CorporationUpdateRequest({ ...initialValue, ...updates }),
    });
}

export async function updateCorporationKcfInformation(
    corporationId: string,
    currentValue: ICorporationKcfInformationResponse,
    updates: Partial<ICorporationKcfInformationUpdateRequest>
) {
    return sdClient.updateCorporationKcfInformation({
        id: corporationId,
        body: new CorporationKcfInformationUpdateRequest({
            NetSuiteId: currentValue.NetSuiteId,
            ...updates,
        }),
    });
}
